import Component, { mixins } from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import WithRender from './SessionSelect.html'

import { 
  MDropdown,
  MDropdownItem,
  MTooltip
} from '@ulaval/modul-components'

import ISessionDossierExamen from '@/modules/inscription-lieu-examen/IDossierEtudiant.model'
import IDossierEtudiant from '@/modules/inscription-lieu-examen/IDossierEtudiant.model'

import { STORE_GETTERS } from '@/store'
import ROUTES from '@/router/ROUTES'
import { extractLocalizedRouteParameters } from '@/router/helpers'

@WithRender
@Component({
  components: {
    MDropdown,
    MDropdownItem,
    MTooltip
  }
})
export default class SessionSelect extends mixins() {
  private selectedSession: ISessionDossierExamen | null = null

  private get dossierEtudiant(): IDossierEtudiant | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_DOSSIER_ETUDIANT]
  }
  
  private get availableSessions(): Array<ISessionDossierExamen> {
    if (!this.dossierEtudiant) {
      return []
    }

    return this.dossierEtudiant.sessionsDossierExamen || []
  }

  private get hasAvailableSessions(): boolean {
    return this.availableSessions.length > 0
  }

  @Watch('dossierEtudiant', { immediate: true })
  private onDossierEtudiantChange(dossierEtudiant: IDossierEtudiant | null): void {
    if (dossierEtudiant) {
      this.setSelectedSessionFromDossierEtudiant(dossierEtudiant)
    }
  }

  @Watch('selectedSession')
  private onSelectedSessionChange(session: ISessionDossierExamen | null) {
    if (session && this.$route.params.token !== session.token) {
      this.mixin_router_navigate({
        name: ROUTES.INSCRIPTION_ETUDIANT,
        params: {
          ...this.$route.params,
          token: session.token
        },
        query: {
          ...this.$route.query,
          'code-session': session.codeSession
        }
      })
    }
  }

  private setSelectedSessionFromDossierEtudiant(dossierEtudiant: IDossierEtudiant): void {
    const matchingSession: ISessionDossierExamen | undefined = this.availableSessions.find((session: ISessionDossierExamen) => {
      return session.codeSession === dossierEtudiant.session.codeSession
    })

    this.selectedSession = matchingSession || null

    if (matchingSession) {
      this.mixin_router_navigate({
        name: extractLocalizedRouteParameters(this.$route.name as string).name,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          'code-session': matchingSession.codeSession
        }
      })
    }
  }
}
